module.exports = __webpack_public_path__ + "assets/a08fd21ad6fc310254a290c634cab290.png";